<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Laudos Excluídos e Cancelados</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input
              label="Placa"
              mask="AAA-0A00"
              placeholder="Digite aqui"
              name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Criação Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Criação Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"
            ></app-input>
          </form>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela
          [data]="tableData"
          [columns]="tableColumns"
        ></app-tabela>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa"
        mask="AAA-0A00"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Criação Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Criação Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"
      ></app-input>
    </form>

    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true"
    ></app-card>
  </div>

  <app-subtitulo *ngIf="!tableData.length">Nenhum registro encontrado.</app-subtitulo>

  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
